module.exports = __webpack_public_path__ + "img/Logo_white.954435eb.svg";